// loadGtmScript.js
import { withScope, captureException } from '@sentry/browser';

import loadScriptTag from '../resource/loadScriptTag.js';

const isClient = typeof window !== 'undefined';
const scriptId = 'gtm-script';

const loadGtmScript = ({ gtmId, dataLayer }) =>
  new Promise(resolve => {
    if (!isClient) return resolve(null);
    const gtmScriptUrl = new URL('gtm.js', 'https://www.googletagmanager.com/');
    gtmScriptUrl.searchParams.set('id', gtmId);
    gtmScriptUrl.searchParams.set('l', dataLayer);
    return loadScriptTag({
      id: scriptId,
      src: gtmScriptUrl.href,
      onError: () => {
        withScope(scope => {
          scope.setExtra('scriptId', scriptId);
          scope.setExtra('scriptSrc', gtmScriptUrl.href);
          captureException(new Error('<script> failed to load.'));
        });
        resolve(null);
      },
      onLoad: result => {
        return resolve(result);
      },
    });
  });

export default loadGtmScript;
